import {Link} from 'react-router';
import {getCurrentProjectName} from '../url';

const projectName = getCurrentProjectName();
const Footer = () => {
    return (
        <footer className="shadow-sm bg-gray-900">
            <div className="w-full max-w-screen-xl mx-auto p-4 md:py-8">
                <div className="sm:flex sm:items-center sm:justify-between">
                    <Link to="/"
                          className="flex items-center mb-4 sm:mb-0 space-x-3 rtl:space-x-reverse">
                        <span
                            className="self-center text-2xl font-semibold whitespace-nowrap text-white">{projectName}</span>
                    </Link>
                    <ul className="flex flex-wrap items-center mb-6 text-sm font-medium sm:mb-0 text-gray-400">

                        <li>
                            <Link to="/terms-condition" className="hover:underline me-4 md:me-6">Terms&Conditions</Link>
                        </li>
                        <li>
                            <Link to="/services" className="hover:underline me-4 md:me-6">Services</Link>
                        </li>
                        <li>
                            <Link to="/slots" className="hover:underline me-4 md:me-6">Portfolio</Link>
                        </li>
                        <li>
                            <Link to="/contact" className="hover:underline">Contact</Link>
                        </li>
                    </ul>
                </div>
                <div className={"social flex justify-end space-x-6 mt-4 mb-4"}>
                    <ul className={"flex flex-wrap items-end mb-6 text-sm font-medium sm:mb-0 text-gray-400"}>
                        <li className={"flex gap-5"}>
                            <a href="https://www.linkedin.com/in/lesia-k-93856a16/" target="_blank" rel="noopener noreferrer"
                               className="hover:underline me-4 md:me-6">
                                <img
                                    className={"w-6 h-6 invert hover:scale-110"}
                                    alt="LinkedIn"
                                    src={"/assets/linkedin.svg"}
                                />
                            </a>
                        </li>
                    </ul>

                </div>

                <hr className="my-6 sm:mx-auto border-gray-700 lg:my-8"/>
                <span className="block text-sm  sm:text-center text-gray-400">© 2025 <Link
                    to="/" className="hover:underline">{projectName}</Link>. All Rights Reserved.</span>
            </div>
        </footer>


    )
}

export default Footer;
